import styled from "styled-components";

export const Container = styled.div``;
export const PopContainer = styled.div`
  padding: 0;
  .modal-body {
    padding: 10px 29px;
    .input-wrapper {
      margin-bottom: 18px;
      p {
        font-size: 13px;
        line-height: 150.5%;
        color: #000;
        margin-bottom: 10px;
      }
      input {
        background: #ffffff;
        border: 1px solid #cdcfd0;
        border-radius: 6px;
        max-width: 344px;
        width: 100%;
        height: 26px;
        margin-bottom: 14px;
        padding: 0 8px;
      }
      .des {
        color: #636f7c;
        font-size: 12px;
      }
    }
  }
`;

export const MsgActionBtn = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  margin-top: 10px;
  padding: 0 21px 20px;

  button {
    width: 111px;
    height: 43px;
    background: transparent;
    border-radius: 30px;
    border: 1px solid #636f7c;
    font-family: "latobold";
    font-size: 16px;
    :last-child {
      background: var(--theme-background);
      color: #fff;
      border: none;
    }
  }
`;
export const ModalHeader = styled.h3`
  font-size: 14px;
  line-height: 150.5%;
  padding: 10px 28px;
  background: var(--filter-bar-bg);
  border-radius: 5px 5px 0px 0px;
  color: var(--theme-text);
`;
export const Header = styled.div`
  padding: 12px 20px;
  /* height: 53px; */
  display: flex;
  align-items: stretch;
  border-left: 1px solid #cdcfd0;
  background: var(--filter-bar-bg);
  color: var(--theme-text);
  gap: 16px;
  justify-content: flex-start;
  margin-left: -1px;
  &.edit-campaign-header {
    justify-content: space-between;
  }
  .input-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    span {
      color: #1c1c1c7d;
    }
  }
  > .border-right {
    border-right: 1px solid #cdcfd0;
    margin: 0px 16px;
    display: flex;
  }
`;

export const Wrapper = styled.div`
  /* padding: 40px; */
  background: #fafcff;
`;

export const Section = styled.div`
  background: #ffffff;
  box-shadow: 2px 4px 5px 2px rgba(0, 0, 0, 0.02);
  padding: 0 25px;
  max-height: calc(100vh - 130px);
  overflow: auto;
  &.campaigns-main-section {
    max-height: calc(100vh - 300px);
  }
  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    min-height: 75px;
    border-bottom: 1px solid #d1d0cb;
    h4 {
      font-size: 18px;
      line-height: 150.5%;
      font-family: "latobold";
    }
    .action-wrapper {
      display: flex;
      align-items: center;
      gap: 15px;
    }
  }
`;

export const BodySection = styled.div`
  > div {
    flex: 1;
    display: flex;

    :nth-child(2) {
    }
  }
`;
export const TableSection = styled.div``;
export const CalendarSection = styled.div``;
export const IconWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  width: 100%;
  button {
    background: transparent;
    border: none;
    padding: 0;
  }
  svg {
    cursor: pointer;
  }

  > div {
    display: flex;
    align-items: center;
    gap: 15px;
    justify-content: flex-end;
  }
`;
export const TableContainer = styled.div`
  max-height: calc(100vh - 292px);
  overflow: auto;
  .MuiDataGrid-columnHeaders {
    min-height: 41px !important;
  }

  /* .MuiTableHead-root {
  background: #D0E8FF;
} */
  .MuiTableCell-root {
    text-align: center;
    border: 0.5px solid rgba(185, 185, 185, 0.5);
  }
  .MuiTableCell-head {
    font-size: 12px;
    font-family: "latoregular";
    padding: 8px;
    color: #4b4b4b;
    background: #d0e8ff;
  }
  .MuiTableCell-body {
    font-size: 12px;
    line-height: 14px;
    color: #000000;
    font-family: "latoregular";
    padding: 10px;
  }
`;

export const Info = styled.div`
  display: flex;
  gap: 10px 25px;
  flex-wrap: wrap;
  padding: 21px 0 26px;
  justify-content: flex-end;

  > div {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    line-height: 17px;
  }
`;
export const MainDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  width: 100% !important;
  align-items: flex-end;
  > p {
    align-self: flex-start;
  }
  &.single-icon {
    ${IconWrapper} {
      justify-content: flex-end;
      display: flex;
    }
  }
`;
export const DataSection = styled.div`
  display: flex;
  gap: 23px;
  min-height: calc(100vh - 273px);
  .publish-data-text {
    padding: 10px;
    font-size: 14px;
  }
  > div {
    flex: 1;
    border: 1px solid #b9b9b9;
    display: grid;
    grid-template-rows: 1fr auto auto;
  }
`;

export const DataTableContainer = styled.div`

  height: 400px;
  & > div {
    text-align: center;
  }

  &.no-pagination{
    .MuiDataGrid-footerContainer {
      display: none !important;
    }
  }
`;

export const CampaignMissingContainer = styled.div`
  height: 400px;
  & > div > p {
    color: "red";
  }
`;

export const DatesMatchContainer = styled.div`
  color: red;
  text-align: center;
  margin-top: 5px;
  position: relative;
  height: 35px;
  & > div {
    background-color: yellow;
    width: 112px;
    position: absolute;
    left: 269px;
    height: 35px;
    padding-top: 8px;
  }
`;

export const CircleBtn = styled.button`
  height: 36px;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  font-size: 12px;
  line-height: 150.5%;
  background-color: var(--theme-background);
  color: white;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 12px;
  align-items: center;
  justify-content: center;
  /* margin: 9px 0px; */
  /* cursor: pointer;
  font-family: "latoregular"; */
`;

export const NormalBtn = styled.span`
button{
  height: 30px;
  border: 1px solid var(--border-color);
  border-radius: 30px;
  font-size: 11px;
  background-color: var(--theme-text);
  display: flex;
  align-items: center;
  padding: 0 12px;
  align-items: center;
  justify-content: center;
  text-transform: initial;
  color: inherit;
    &.active {
      background: rgb(188,155,106);
    color: rgb(255,255,255);
    border-color: transparent;
    }
}
  
  /* cursor: pointer;
  font-family: "latoregular"; */
`;
